import './style.css'
import { HeaderComponent } from '../../components/headerComponet'
import { RegistrationStage } from './Components/registrationStage'
import { RegisterFormGroup } from './Components/RegisterFormGroup'
import { useEffect, useState } from 'react'
import UserService from '../../services/UserService'
import { RegisterFormAttendance } from './Components/RegisterFormAttendance'
import { ActiveItemProvider } from './context/ActiveItemContext'
import { AtendimentoComunication } from './context/ComunicationContext'
import { UserRole } from '../../enums/UserRole'
import { useClient } from '../../contexts/ClientContext'

import { Atendimento } from '@/interfaces/AttendanceData'
import { useLocation, useNavigate } from 'react-router-dom'
import { AtendimentoEstadoProvider } from './context/AtendimentoEstadoContextProps'
import { DrawerComponent } from '@/components/DrawerComponent'
import attendanceApi from '@/services/api/attendance'

export function HomePage() {
  const [expanded, setExpanded] = useState<boolean>(true)
  const [showRegisterForm, setShowRegisterForm] = useState(false)
  // const [idBriefing, setIdBriefing] = useState<number>(0);
  const [atendimentos, setAtendimentos] = useState<Atendimento[]>([])

  const clientContext = useClient()
  const location = useLocation()
  const navigate = useNavigate()

  const queryParams = new URLSearchParams(location.search)
  const clientId = Number(queryParams.get('cliente'))
  const atendimentoId = Number(queryParams.get('atendimentoId'))

  useEffect(() => {
    if (!UserService.isAuthenticated()) {
      window.location.href = '/'
    }
  }, [])

  const user = UserService.getUser()

  useEffect(() => {
    console.log("kanban: ", clientContext.client)
    if (clientId && clientContext.clientes.length > 0) {
      // Buscar o cliente correspondente com base no clientId
      let selectedClient = clientContext.clientes.find(
        (client) => client.Client.id === clientId
      );
  
      if (selectedClient) {

        let atendimentoAtualId = selectedClient.Client.atendimentoAtualId;


        if(atendimentoId){
          atendimentoAtualId = atendimentoId;
        }


        clientContext.setClient({...selectedClient.Client, atendimentoAtualId: atendimentoAtualId});

        setShowRegisterForm(true); // Mostrar o formulário automaticamente

        // Filtrar os atendimentos para o cliente específico
        const atendimentosPorClienteId = clientContext.atendimentos.filter(
          (atendimento) => atendimento.cliente_id === clientId
        );
        setAtendimentos(atendimentosPorClienteId);
        
        // Remover o query parameter da URL depois de carregar os dados
        navigate('/homepage', { replace: true });

        setExpanded(true); // Expande o formulário automaticamente
      }
    }
  }, [clientId, clientContext.clientes, clientContext.atendimentos, navigate]);  

  useEffect(() => {
    try {
      clientContext.reloadClientes();
    } catch (err) {
      console.log(err);
    }
  }, []);

  async function getAtendimentos() {
    if (clientContext.client.id !== undefined) {
      const response = await attendanceApi.buscarAtendimentoPorCliente(clientContext.client.id)
      setAtendimentos(response.data)
    }
  }

  useEffect(() => {
    if (clientContext.client.id !== undefined && clientContext.client.id !== null) {
      getAtendimentos()
    }
  }, [clientContext.client.id, clientContext.atendimentos])

  return (
    <div className='main-layout'>
      {user?.role &&
        (user.role.includes(UserRole.ADMIN) ||
          user.role.includes(UserRole.PROJETISTA)) ? (
        <>
          <ActiveItemProvider>
            <DrawerComponent /> {/* Check */}
          </ActiveItemProvider>
          <div className='main-content'>
            <HeaderComponent /> {/* Check */}
            <div className='content-container'>
              <AtendimentoComunication>
                {/* Lista de clientes */}
                <RegistrationStage
                  expanded={expanded}
                  setExpanded={setExpanded}
                  onRegisterClick={() => {
                    setShowRegisterForm(true)
                  }}

                //mudar para context, não vai mais ser utilizado
                // onDataChange={setData}
                />
                {(showRegisterForm || clientContext.client.id) && (
                  <div className='container-record'>
                    {/* Form para registrar cliente */}
                    <RegisterFormGroup
                      expanded={expanded}
                      isUpdateMode={clientContext.client && clientContext.client.id ? true : false}
                    />
                    {clientContext.client.atendimentoAtualId ? (
                      <AtendimentoEstadoProvider>
                        {atendimentos
                          .sort((a, b) => {
                            if (a.arquivado !== b.arquivado) {
                              return Number(a.arquivado) - Number(b.arquivado)
                            }
                            return b.id - a.id
                          })
                          .map((atendimento) => {
                          return (
                            <RegisterFormAttendance
                              key={atendimento.id}
                              idBriefing={atendimento.briefingId}
                              idAttendance={atendimento.id}
                              createdAt={atendimento.criadoEm}
                              statusEstado={atendimento.estado}
                            />
                          )
                        })}
                      </AtendimentoEstadoProvider>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </AtendimentoComunication>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          Ops... ainda estamos trabalhando nessa página, volte mais tarde
          <a
            href='/'
            style={{ textAlign: 'center' }}
            onClick={() => {
              localStorage.removeItem('userJwt')
            }}
          >
            Login
          </a>
        </div>
      )}
    </div>
  )
}
